import React from 'react';
import { Room } from '../../libs/gs-component-hotel-planner';
import { Body2 } from '@xo-union/tk-ui-typography';
import AddToWebsite from './AddToWebsite';
import styles from './styles.scss';

interface Props {
  room: Room;
  onClick: (room: Room) => void;
}

const TransientRoom: React.FC<Props> = ({ room, onClick }) => {
  const { propertyId, imagePath, propertyName } = room;
  return (
    <div className={styles.transientRoom__room}>
      <Body2 className={styles.transientRoom__propertyName}>{propertyName}</Body2>
      <button className={styles.roomImageLink} onClick={(): void => onClick(room)}>
        {imagePath && <img src={imagePath} alt={propertyName} className={styles.transientRoom__room__image} />}
      </button>
      <AddToWebsite propertyId={propertyId} onClick={(): void => onClick(room)} />
    </div>
  );
};

export default TransientRoom;
